import React, { useState } from 'react';
import { object } from 'prop-types';
import loadable from '@loadable/component';
import getQueryValue from '@helpers/getQueryValue';
/**
 * List of local components
 */
import MainLayout from '@components/Layout';
import WelcomeSection from '@components/WelcomeSection';
import FloatingMusic from '@components/FloatingMusic/Loadable';

// Lazy load heavy components using @loadable/component (better SSR support)
const HelloSection = loadable(() => import('@components/HelloSection'));
const WeddingSection = loadable(() => import('@components/WeddingSection'));
const StorySection = loadable(() => import('@components/StorySection'));
const PhotoSection = loadable(() => import('@components/PhotoSection/Loadable'));
const ConfirmationSection = loadable(() => import('@components/ConfirmationSection'));
const FooterSection = loadable(() => import('@components/FooterSection'));

function Home({ location }) {
  const guestName = decodeURIComponent(getQueryValue(location, 'to') || '');
  const type = decodeURIComponent(getQueryValue(location, 'type') || '');
  const isAnonymGuest = !guestName;

  const [showDetailContent, setShowDetailContent] = useState(false);

  const handleClickDetail = () => {
    setShowDetailContent(true);
  };

  const renderDetailContent = () => {
    if (!showDetailContent) {
      return null;
    }
    return (
      <>
        <HelloSection isInvitation={false} />
        <WeddingSection isInvitation={false} />
        <StorySection />
        <PhotoSection />
        <ConfirmationSection guestName={guestName} codeLink="" isInvitation={false} />
        {/* <WishesSection /> */}
        <FooterSection isInvitation={false} />
      </>
    );
  };

  return (
    <MainLayout>
      <WelcomeSection
        guestName={guestName}
        isAnonymGuest={isAnonymGuest}
        isInvitation={false}
        type={type}
        location={location}
        onClickDetail={handleClickDetail}
      />
      {renderDetailContent()}
      <FloatingMusic />
    </MainLayout>
  );
}

Home.propTypes = {
  location: object.isRequired,
};

export default Home;
